import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type ReservationProfile } from '../domain/reservationProfile';

const initialState: { list: ReservationProfile[] } = { list: [] };

const reservationProfilesSlice = createSlice({
    initialState,
    name: 'reservationProfiles',
    reducers: {
        clearReservationProfiles: () => initialState,
        setReservationProfiles: (state, action: PayloadAction<ReservationProfile[]>) => {
            state.list = action.payload;
        },
    },
});

export const { clearReservationProfiles, setReservationProfiles } = reservationProfilesSlice.actions;
export default reservationProfilesSlice.reducer;
